import {createApi} from "@reduxjs/toolkit/query/react";
import {axiosBaseQuery} from "./axiosBaseQuery";

const trimData = (data) => {
    if (typeof data === 'string') {
        return data.trim();
    }
    if (Array.isArray(data)) {
        return data.map((item) => trimData(item));
    }
    if (data && typeof data === 'object') {
        return Object.fromEntries(
            Object.entries(data).map(([key, value]) => [key, trimData(value)])
        );
    }
    return data;
};

export const usersApi = createApi({
    reducerPath: 'usersApi',
    baseQuery: axiosBaseQuery({
        baseUrl: '/users/api',
    }),
    tagTypes: ['users'],
    endpoints: (build) => ({
        isMember: build.mutation({
            query: (data) => ({
                url: '/details/is-member',
                method: 'POST',
                data: trimData(data),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
        }),
        isMemberFirstLogin: build.mutation({
            query: (data) => ({
                url: '/details/first-login',
                method: 'POST',
                data: trimData(data),
                popupOnError: true
            })
        }),
        register: build.mutation({
            query: (data) => ({
                url: '/details/register',
                method: 'POST',
                data: trimData(data),
                popupOnError: false
            })
        }),
        editUserInformation: build.mutation({
            query: (data) => ({
                url: '/details/editUserInformation',
                method: 'POST',
                data: trimData(data),
                popupOnError: false
            })
        }),
        generateOtp: build.mutation({
            query: (data) => ({
                url: '/auth/generate-otp',
                method: 'POST',
                data: trimData(data),
                popupOnError: false
            })
        }),
        validateOtp: build.mutation({
            query: (data) => ({
                url: '/auth/validate-otp',
                method: 'POST',
                data: trimData(data),
                popupOnError: false
            })
        }),
        getUserFavorites: build.mutation({
            query: (data) => ({
                url: '/favourites/getUserFavourites',
                method: 'POST',
                data: trimData(data),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
        })
    })
})

export const {  
    useIsMemberMutation,
    useIsMemberFirstLoginMutation,  
    useGenerateOtpMutation,
    useValidateOtpMutation,
    useRegisterMutation,
    useEditUserInformationMutation,
    useGetUserFavoritesMutation,
} = usersApi

